exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ol.numbered[data-v-35e8a171] {\n  margin-left: 1.2em;\n}\nol.numbered > li[data-v-35e8a171] {\n  list-style: decimal;\n}", ""]);

// exports
